import React from 'react';
import FooterCard from './FooterCard';
function Footer() {
  return (
    <footer className="relative bg-primary font-ec py-0.5">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row flex-wrap justify-center items-stretch">
        <FooterCard title="和達法律事務所">
          <p>電話：02-27018356</p>
          <p>Email: hedalawfirm@gmail.com</p>
          <p>地址：106625 臺北市大安區復興南路二段86號3樓之1</p>
        </FooterCard>
        <FooterCard title="停車資訊">
          <div className="w-full h-64">
            <iframe
              title="停車場資訊"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.042176602427!2d121.54094069999998!3d25.032642700000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442abd4c68931f5%3A0x9da9d77a51210616!2z5Zif5Zif5oi_LeWkp-WuiemrmOW3peWcsOS4i-WBnOi7iuWgtA!5e0!3m2!1szh-TW!2stw!4v1756313313405!5m2!1szh-TW!2stw"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </FooterCard>
      </div>
      <div className="text-center text-textOppPrimary mt-8 text-sm">
        © 2025 HedaLaw. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
